<template>
  <div class="my_table_config">
    <h3 v-if="
      isTableNameVisible &&
      tableConfig.TableName &&
      tableConfig.TableName != ''
    ">
      {{ tableConfig.TableName }}
    </h3>
    <table class="item-content" v-if="tbOption == 1 || tbOption == 2">
      <tr v-for="(item, index) in tableConfig.ItemList" :key="index" v-if="item.IsShow">
        <td :class="item.ItemType == -1 ? 'item-header' : 'dialog-title'" :colspan="item.ItemType == -1 ? 2 : 1">
          <span class="TipRequired" v-if="item.IsRequired && item.IsRequired == 1">
            *
          </span>
          {{ item.ItemName }}
        </td>
        <td class="dialog-cnt" v-if="item.ItemType != -1" @click="SelectItem(index)">
          <!-- 处理单选题 -->
          <el-radio-group v-model="item.AnswerList[0]" @input="radioGroupInput(item)"
            v-if="item.ItemType == 1 && item.ShowType == 2">
            <el-radio :label="oitem.TBCItemAnswerID" v-for="oitem in item.ItemAnswerList">{{ oitem.AnswerName }}
            </el-radio>
          </el-radio-group>
          <el-select :placeholder="item.Placeholder" @change="selectChange" v-model="item.AnswerList[0]"
            v-if="item.ItemType == 1 && item.ShowType == 1">
            <el-option v-for="oitem in item.ItemAnswerList" :key="oitem.TBCItemAnswerID" :label="oitem.AnswerName"
              :value="oitem.TBCItemAnswerID"></el-option>
          </el-select>
          <!-- 处理填空题 -->
          <el-input v-model="item.AnswerResult" :placeholder="item.Placeholder" v-if="item.ItemType == 3"
            :maxlength="item.TextLength"></el-input>
          <!-- 处理日期选择题 -->
          <el-date-picker v-model="item.AnswerResult" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            :picker-options="pickerOptions" :placeholder="item.Placeholder" v-if="item.ItemType == 5"></el-date-picker>
          <!-- 处理简答题 -->
          <el-input type="textarea" :placeholder="item.Placeholder" v-model="item.AnswerResult"
            v-if="item.ItemType == 4" resize="none" :maxlength="item.TextLength" show-word-limit>
          </el-input>
          <!-- 处理带操作按钮的简答题 -->
          <el-input type="textarea" :placeholder="item.Placeholder" v-model="item.AnswerResult"
            v-if="item.ItemType == 41 && item.IsSync == undefined" resize="none" :maxlength="item.TextLength"
            style="width:calc(100% - 150px);vertical-align:middle;" show-word-limit>
          </el-input>
          <div
            v-else-if="item.ItemType == 41 && item.AnswerResult != '' && item.IsSync != undefined && item.IsSync == true"
            v-html="item.AnswerResult">
          </div>
          <el-button type="primary" v-if="item.ItemType == 41" round style="margin-left:20px;vertical-align:middle;"
            @click="SyncOnline(index, item)">在线同步
          </el-button>
          <!-- 文件上传 -->
          <el-upload class="upload-demo" :ref="'ref' + item.TBCItemID" action="no" :file-list="item.Files"
            :auto-upload="false" :on-exceed="exceedFile" v-if="item.ItemType == 7" :on-change="successUpload"
            :on-remove="handleRemove"
            :limit="item.TextLength != null && item.TextLength != undefined && item.TextLength > 1 ? item.TextLength : 1"
            :multiple="item.TextLength != null && item.TextLength != undefined && item.TextLength > 1 ? true : false"
            :accept="item.ShowType">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">
              <p>{{ item.Placeholder }}</p>
            </div>
          </el-upload>
        </td>
      </tr>
    </table>

    <div class="my_tc_footer" v-if="isTableNameVisible && (tbOption == 1 || tbOption == 2)">
      <el-button type="success" @click="saveData">保存</el-button>
    </div>
    <table class="item-content" v-if="tbOption == 0">
      <tr v-for="(item, index) in tableConfig.ItemList" :key="index" v-if="item.IsShow">
        <td :class="item.ItemType == -1 ? 'item-header' : 'dialog-title'" :colspan="item.ItemType == -1 ? 2 : 1">
          {{ item.ItemName }}
        </td>
        <td class="dialog-cnt" v-if="item.ItemType == 7">
          <div class="img-list" v-for="(it, idx) in item.AnswerList" :key="idx">
            <el-image style="width: 100%; height: 100%" :src="it" :preview-src-list="item.AnswerList"
              v-if="it != '' && (it.indexOf('.jpg') > -1 || it.indexOf('.png') > -1)">
            </el-image>
            <p class="link-file"
              v-else-if="it != '' && (it.indexOf('.doc') > -1 || it.indexOf('.docx') > -1 || it.indexOf('.pdf') > -1)"
              @click="OpenFile(it)">
              {{
                it
              }}</p>
            <span v-else>【未上传】</span>
          </div>
        </td>
        <td class="dialog-cnt" v-else-if="item.ItemType != -1 && item.ItemType != 41">
          <span :style="{ color: item.AnswerColor }">{{ item.AnswerResult }}</span>
        </td>
        <td class="dialog-cnt" v-else-if="item.ItemType == 41">
          <div v-html="item.AnswerResult"></div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ['isTableNameVisible'],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return Date.now() < time.getTime();
        },
      },
      tbOption: 1, //当前操作状态，1默认状态表示正在添加，0表示数据浏览,2表示修改数据
      TesterID: '',
      GeneralID: '',
      Common: '',
      ItemIndex: -1,
      TableCngID: '',
      TableCngResultID: '',
      tableConfig: { TableName: '' },
    };
  },
  methods: {
    init: function (obj) {
      if (obj.OptionState != undefined) this.tbOption = obj.OptionState;
      if (obj.TesterID != undefined) this.TesterID = obj.TesterID;
      if (obj.GeneralID != undefined) this.GeneralID = obj.GeneralID;
      if (obj.Common != undefined) this.Common = obj.Common;
      if (obj.TableCngID != undefined) this.TableCngID = obj.TableCngID;
      if (obj.TableCngResultID != undefined)
        this.TableCngResultID = obj.TableCngResultID;
      let _this = this;
      if (obj.OptionState == 1 && _this.TableCngResultID == '') {
        this.$Http_Post('ReportCriData/GetTableConfig', {
          TableCode: _this.TableCngID,
          MenuID: _this.Common,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.tableConfig = res.Data;
          } else {
            this.Global.request_failure('获取信息失败');
          }
        });
      } else if (obj.OptionState == 0 || obj.OptionState == 2 || (obj.OptionState == 1 && _this.TableCngResultID != '')) {
        this.$Http_Post('ReportCriData/GetTableResultRecord', {
          TableCode: _this.TableCngID,
          MenuID: _this.Common,
          TableCngResultID: _this.TableCngResultID,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.tableConfig = res.Data;
            if (obj.OptionState == 1 && _this.TableCngResultID != '') _this.TableCngResultID = ''
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    setTableConfig: function (obj) {
      this.tbOption = obj.OptionState;
      this.tableConfig = obj.TableConfig;
    },
    setOptionState: function (state) {
      this.tbOption = state;
    },
    SyncOnline(idx, obj) {
      if (obj.ShowType != null || obj.ShowType != "") {
        let _this = this
        this.$Http_Post(obj.ShowType, { UserID: this.TesterID })
          .then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              if (res.Data.length > 0) {
                _this.tableConfig.ItemList[idx].AnswerResult = res.Data
                _this.tableConfig.ItemList[idx].IsSync = true
              }
            }
          })
          .catch((err) => { });
      }
    },
    saveData: function () {
      let _this = this;
      // 保存前先进行验证，主要是必填内容
      let checkResult = true;
      let msg = '';
      for (let i = 0; i < this.tableConfig.ItemList.length; i++) {
        if (
          _this.tableConfig.ItemList[i].IsRequired &&
          _this.tableConfig.ItemList[i].IsRequired == 1
        ) {
          if (
            _this.tableConfig.ItemList[i].ItemType == 1 &&
            (_this.tableConfig.ItemList[i].AnswerList[0] == null ||
              _this.tableConfig.ItemList[i].AnswerList[0] == '')
          ) {
            checkResult = false;
            msg = '请选择' + _this.tableConfig.ItemList[i].ItemName;
            break;
          }
        }
      }
      //判断文件上传的情况
      let upLoadTotleCount = 0;
      let upLoadOkCount = 0;
      for (let m = 0; m < _this.tableConfig.ItemList.length; m++) {
        if (
          _this.tableConfig.ItemList[m].ItemType == 7 &&
          _this.tableConfig.ItemList[m].Files != undefined &&
          _this.tableConfig.ItemList[m].Files.length > 0
        ) {
          upLoadTotleCount++;
        }
      }
      if (checkResult == false) {
        this.$notify.closeAll();
        this.$notify.error({
          title: '错误',
          message: msg,
        });
      } else if (upLoadTotleCount == 0) _this.submitData();
      else {
        for (let j = 0; j < _this.tableConfig.ItemList.length; j++) {
          if (
            _this.tableConfig.ItemList[j].ItemType == 7 &&
            _this.tableConfig.ItemList[j].Files != undefined &&
            _this.tableConfig.ItemList[j].Files.length > 0
          ) {
            let formData = new FormData();
            for (
              let k = 0;
              k < _this.tableConfig.ItemList[j].Files.length;
              k++
            ) {
              formData.append('file', _this.tableConfig.ItemList[j].Files[k]);
            }
            formData.append('id', this.tableConfig.ItemList[j].TBCItemID);
            formData.append('fileType', this.tableConfig.ItemList[j].ShowType);
            this.$Http_Post('ReportCriData/UploadFile', formData, {
              'Content-Type': 'multipart/form-data',
            })
              .then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.tableConfig.ItemList[j].AnswerList = res.Data;
                  upLoadOkCount++;
                  if (upLoadTotleCount == upLoadOkCount) _this.submitData();
                } else {
                  this.Global.request_failure(res.Message);
                }
              })
              .catch((err) => { });
          }
        }
      }
    },
    radioGroupInput: function (obj) {
      for (let i = 0; i < this.tableConfig.ItemList.length; i++) {
        if (this.tableConfig.ItemList[i].ShowAnswerID != null && this.tableConfig.ItemList[i].ShowItemID == obj.TBCItemID) {
          if (this.tableConfig.ItemList[i].ShowAnswerID == obj.AnswerList[0]) this.tableConfig.ItemList[i].IsShow = true
          else this.tableConfig.ItemList[i].IsShow = false
        }
      }
    },
    selectChange: function (obj) {
    },
    submitData() {
      this.$Http_Post('ReportCriData/SubmitTBData', {
        GeneralID: this.GeneralID,
        Common: this.Common,
        TesterID: this.TesterID,
        TableConfig: this.tableConfig,
        Option: this.tbOption,
        ResultID: this.TableCngResultID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$emit('dialogHandleClose');
          this.Global.request_successful(res.Message);
        } else {
          this.Global.request_failure('获取信息失败');
        }
      });
    },
    exportData: function () {
      this.$parent.SubmitUserData(this.tableConfig);
    },
    exceedFile(files, fileList) {
      let fileCount =
        this.tableConfig.ItemList[this.ItemIndex].TextLength == 0
          ? 1
          : this.tableConfig.ItemList[this.ItemIndex].TextLength;
      this.$message.closeAll();
      this.$message.warning(
        `只能选择 ${fileCount} 个文件，当前共选择了 ${files.length +
        fileList.length} 个`
      );
    },
    SelectItem(iindex) {
      this.ItemIndex = iindex;
    },
    successUpload(files, fileList) {
      var fileTypes = this.tableConfig.ItemList[this.ItemIndex].ShowType
      var curType = files.name.replace(/.+\./, '')
      if (fileTypes.indexOf(curType.toLowerCase()) === -1) {
        this.Global.request_info(this.tableConfig.ItemList[this.ItemIndex].Placeholder);
        this.tableConfig.ItemList[this.ItemIndex].Files = []
      }
      else {
        let fs = [];
        for (let i = 0; i < fileList.length; i++) {
          fs.push(fileList[i].raw);
        }
        this.tableConfig.ItemList[this.ItemIndex].Files = fs
      }
    },
    handleRemove(files, fileList) {
      let fs = [];
      for (let i = 0; i < fileList.length; i++) {
        fs.push(fileList[i].raw);
      }
      this.tableConfig.ItemList[this.ItemIndex].Files = fs;
    },
    OpenFile(filePath) {
      window.open(filePath, '_blank')
    }
  },
};
</script>
<style>
h3 {
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.TipRequired {
  color: red;
}

.my_tc_footer {
  text-align: center;
  height: 50px;
  margin-top: 20px;
}

.img-list img {
  height: 80px;
  width: 100px;
  float: left;
  margin-right: 5px;
}

.link-file {
  color: rgb(0, 183, 255);
  text-decoration: underline;
  cursor: pointer;
}
</style>
